import React, { useState } from 'react';
import CodeEditor from '../CodeEditor/CodeEditor';
import './MultiCodeEditor.css';

const MultiCodeEditor = ({ 
  htmlCode, 
  cssCode, 
  jsCode, 
  onHtmlChange, 
  onCssChange, 
  onJsChange,
  htmlStarter = '',
  cssStarter = '',
  jsStarter = '',
  height = '100%'
}) => {
  const [activeTab, setActiveTab] = useState('html');

  return (
    <div className="multi-code-editor">
      <div className="editor-tabs">
        <button
          className={`tab ${activeTab === 'html' ? 'active' : ''}`}
          onClick={() => setActiveTab('html')}
        >
          HTML
        </button>
        <button
          className={`tab ${activeTab === 'css' ? 'active' : ''}`}
          onClick={() => setActiveTab('css')}
        >
          CSS
        </button>
        <button
          className={`tab ${activeTab === 'js' ? 'active' : ''}`}
          onClick={() => setActiveTab('js')}
        >
          JavaScript
        </button>
      </div>
      <div className="editor-content">
        {activeTab === 'html' && (
          <CodeEditor
            value={htmlCode || htmlStarter}
            onChange={onHtmlChange}
            language="html"
            height={height}
          />
        )}
        {activeTab === 'css' && (
          <CodeEditor
            value={cssCode || cssStarter}
            onChange={onCssChange}
            language="css"
            height={height}
          />
        )}
        {activeTab === 'js' && (
          <CodeEditor
            value={jsCode || jsStarter}
            onChange={onJsChange}
            language="javascript"
            height={height}
          />
        )}
      </div>
    </div>
  );
};

export default MultiCodeEditor;
